import { OfflineDbService } from '../services/offline-db.service';
import { NetworkStateService } from '../services/network-state.service';
import { LicenseManagementService } from '../../services/license-management.service';
import { isTrialActive } from './trial.util';
import { User } from '../models/models';
import { catchError, map, of, from } from 'rxjs';

/**
 * Prüft zentral, ob Zugriff erlaubt ist:
 * - Trial aktiv -> erlaubt
 * - Offline + Offline-Daten vorhanden -> erlaubt
 * - Sonst Lizenzstatus prüfen
 *
 * Liefert Observable<boolean>.
 */
export function checkLicenseOrTrialOrOffline(
  params: {
    user: User | null;
    licenseService: LicenseManagementService;
    network: NetworkStateService;
    offlineDb: OfflineDbService;
  }
) {
  const { user, licenseService, network, offlineDb } = params;
  const isNative = typeof window !== 'undefined' && !!(window as any).Capacitor?.isNativePlatform?.();

  if (isTrialActive(user)) {
    if (isNative) {
      console.log('[LicDbg] trial active');
    }
    return of(true);
  }

  if (network.isOffline()) {
    return from(offlineDb.getOfflineScheine()).pipe(
      map((scheine) => {
        if (isNative) {
          console.log('[LicDbg] offline scheine count=', scheine?.length || 0);
        }
        return (scheine && scheine.length > 0);
      }),
      catchError((err) => {
        if (isNative) {
          console.log('[LicDbg][offline] error', err);
        }
        return of(false);
      })
    );
  }

  return licenseService.getLicenseStatusCached().pipe(
    map((status) => {
      if (isNative) {
        console.log('[LicDbg] status success=', status?.success, 'active=', !!status?.active_license, 'expires=', status?.active_license?.expires_at || null);
      }
      const lic = status?.active_license;
      if (!lic) return false;
      const validStatus = lic.status === 1;
      const notExpired = lic.expires_at ? new Date(lic.expires_at) >= new Date() : true;
      return validStatus && notExpired;
    }),
    catchError((err) => {
      if (isNative) {
        console.log('[LicDbg][error]', err);
      }
      return of(false);
    })
  );
}
